import { render } from "./Demandas.vue?vue&type=template&id=a61b4210&scoped=true"
import script from "./Demandas.vue?vue&type=script&lang=js"
export * from "./Demandas.vue?vue&type=script&lang=js"

import "./Demandas.vue?vue&type=style&index=0&id=a61b4210&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61b4210"]])

export default __exports__